import React, {Component} from 'react';
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import Table, {TableRow, TableCell} from "@amzn/meridian/table";
import Icon from "@amzn/meridian/icon"
import editTokens from "@amzn/meridian-tokens/base/icon/edit"
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Currency from "../../common/currency";
import PhoneTool from "../../common/phoneTool";
import {getStationCode} from "../../../network/NetworkUtil";
import {getRemittanceList} from "../network/RemittanceAPI";
import {getStationLiabilitySummary} from "../../codSummary/network/StationEODSummaryAPI";
import Moment from "moment";
import CreateRemittanceModal from "../../modal/createRemittanceModal";
import AddDepositModal from "../../modal/addDepositModal";
import EditRemittanceModal from "../../modal/editRemittanceModal";
import AppLoader from "../../common/appLoader";
import AppNotification from "../../common/appNotification";
import {AppConstants, Metric, PROCESS_NAME} from "../../common/constants";
import RemittanceListDateFilter from "./RemittanceListDateFilter";
import DateFilterForRemittance from "../../common/dateFilterForRemittance";
import RemittanceExcelDownload from "./RemittanceExcelDownload";
import {fetchCountryCode, getFeaturesFromParent} from "../../handler/ParentDataHandler";
import CreateRemittanceV2Modal from '../../modal/createRemittanceV2Modal';
import VerifyRemittanceV2Modal from '../../modal/verifyRemittanceV2Modal';
import { RemittanceStatus } from '../../common/remittanceV2Constants';
import { publishCount } from '../../../MetricUtility';


const IS_SUBMIT_REMITTANCE_V2_ENABLED_FLAG = "isSubmitRemittanceV2Enabled";

class RemittanceList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            countryCode: "",
            remittanceList: [],
            openPrepareDepositModal: false,
            openAddDepositModal: false,
            openEditRemittanceModal: false,
            liabilitySummary: {},
            addDepositModalData: {},
            editRemittanceModalData: {},
            showLoader: true,
            hasError: false,
            filters: {
                showFilter: false,
                startDate: Moment().subtract(15, 'days').format('YYYY-MM-DD'),
                endDate: Moment().format('YYYY-MM-DD')
            },
            submitRemittanceV2Flag: false,
            openCreateRemittanceV2Modal: false,
            openVerifyRemittanceV2Modal: false,
            isVerified: false,
            remittanceV2ButtonState: RemittanceStatus.SUBMITTED,
            currencyUnit: "INR" // default currency unit
        };

        this.togglePrepareDepositModal = this.togglePrepareDepositModal.bind(this);
        this.toggleAddDepositModal = this.toggleAddDepositModal.bind(this);
        this.toggleEditRemittanceModal = this.toggleEditRemittanceModal.bind(this);
        this.toggleOptionFilter = this.toggleOptionFilter.bind(this);
        this.onStartDateUpdate = this.onStartDateUpdate.bind(this);
        this.onEndDateUpdate = this.onEndDateUpdate.bind(this);
        this.toggleCreateRemittanceV2Modal = this.toggleCreateRemittanceV2Modal.bind(this);
        this.toggleVerifyRemittanceV2Modal = this.toggleVerifyRemittanceV2Modal.bind(this);
    }

    toggleVerifyRemittanceV2Modal = () => {
        this.setState({
            openVerifyRemittanceV2Modal: !this.state.openVerifyRemittanceV2Modal
        });
    }

    toggleCreateRemittanceV2Modal = () => {
        this.setState({
            openCreateRemittanceV2Modal: !this.state.openCreateRemittanceV2Modal
        });
    }

    /**
     * Set the remittance button state i.e. Create/Verify Remittance
     * @param {List} remittanceList 
     */
    setRemittanceButtonState = (remittanceList) => {
        if (remittanceList.length) {
            this.setState({
                currencyUnit: remittanceList[0].actualAmount.unit
            });
        }

        // Will show `Verify Remttiance Button` if there exists any deposit with PENDING_SUBMISSION status
        // else will show `Create Remittance Button` if there exists any deposit with `CREATED` status
        const pendingRemittaneList = remittanceList.filter(remittance => remittance.status === RemittanceStatus.PENDING_SUBMISSION);
        const remittanceExistsWithPendingSubmissionState = pendingRemittaneList.length > 0;
        const remittanceExistsWithCreatedState = remittanceList.filter(remittance => remittance.status === RemittanceStatus.CREATED).length > 0;
        if (remittanceExistsWithPendingSubmissionState) {
            this.setState({remittanceV2ButtonState: RemittanceStatus.PENDING_SUBMISSION});
            let isVerified = true;
            pendingRemittaneList.forEach(remittance => {
                isVerified = isVerified && remittance.stationVariance.isVerified;
            });
            this.setState({isVerified: isVerified});

        } else if (remittanceExistsWithCreatedState) {
            this.setState({remittanceV2ButtonState: RemittanceStatus.CREATED})
        }
    }
    
    fetchRemittance(){
        const stationCode = getStationCode();
        return getRemittanceList({
            stationCode,
            startDate: Date.parse(this.state.filters.startDate),
            endDate: Date.parse(this.state.filters.endDate) + 86400000 //Add 1 extra day to provide today's data
        }).then(response => {
            if (response.status === 200) {
                const {data: {remittanceList}} = response;
                this.setState({remittanceList});
                this.setRemittanceButtonState(remittanceList);
                publishCount(PROCESS_NAME, Metric.GetRemittance);
            } else {
                this.setState({showLoader: false, hasError: true, errorMessage: "Failed to fetch bank deposits"});
                publishCount(PROCESS_NAME, Metric.GetRemittance_Failure);
                publishCount(PROCESS_NAME, Metric.GetRemittance);
            }
        }).then(() => {
            getStationLiabilitySummary({
                stationCode,
                startTime: AppConstants.LIABILITY_HISTORY_START_TIME,
                endTime: Moment().endOf('day').valueOf()
            }).then(response => {
                if (response.status === 200) {
                    const {data} = response;
                    this.setState({
                        liabilitySummary: data,
                        showLoader: false,
                        hasError: false
                    });
                    publishCount(PROCESS_NAME, Metric.GetStationLiabilitySummary);
                } else {
                    this.setState({showLoader: false, hasError: true, errorMessage: "Failed to station liability"});
                    publishCount(PROCESS_NAME, Metric.GetStationLiabilitySummary_Failure);
                    publishCount(PROCESS_NAME, Metric.GetStationLiabilitySummary);
                }
            });
        }).then(() => {
            fetchCountryCode().then((country) => {
                console.log("fetched country code ->",country)
                this.setState({
                    countryCode: country
                })
            });
        }).catch(err => {
            this.setState({showLoader: false, hasError: true, errorMessage: "Failed to fetch bank deposits"})
        });
    }

    /**
     * Method to set the feature flag IS_SUBMIT_REMITTANCE_V2_ENABLED_FLAG state
     */
    setIsSubmitRemittanceV2Enabled() {
        getFeaturesFromParent([IS_SUBMIT_REMITTANCE_V2_ENABLED_FLAG]).then(featureStatus => {
            this.setState({
                submitRemittanceV2Flag: featureStatus.data.isSubmitRemittanceV2Enabled 
            });
        }).catch(() => {
            this.setState({showLoader: false, hasError: true, errorMessage: "Failed to fetch feature flag"});
            publishCount(PROCESS_NAME, Metric.AppConfigFailure);
        });
    }
    componentWillMount() {
        this.fetchRemittance();
        this.setIsSubmitRemittanceV2Enabled();
    }

    togglePrepareDepositModal = event => {
        this.setState({
            openPrepareDepositModal: !this.state.openPrepareDepositModal
        })
        this.forceUpdate();
    }

    toggleAddDepositModal = event => {
        this.setState({
            openAddDepositModal: !this.state.openAddDepositModal
        })
        if (event !== undefined) {
            this.setState({
                addDepositModalData: this.state.remittanceList[event]
            })
        }
        this.forceUpdate();
    }

    toggleEditRemittanceModal = event => {
        this.setState({
            openEditRemittanceModal: !this.state.openEditRemittanceModal
        })
        if (event !== undefined) {
            this.setState({
                editRemittanceModalData: this.state.remittanceList[event]
            });
        }
        this.forceUpdate();
    }
    toggleOptionFilter() {
        return this.setState(state => (state.filters.showFilter = !state.filters.showFilter));
    }
    onStartDateUpdate(selectedDate) {
        this.setState(state => (state.filters.startDate = selectedDate), () => {
            this.checkAndGetRemittance();
        });
    }
    onEndDateUpdate(selectedDate) {
        this.setState(state => (state.filters.endDate = selectedDate), () => {
            this.checkAndGetRemittance();
        }
        );
    }

    checkAndGetRemittance() {
        var startTime = Date.parse(this.state.filters.startDate);
        var endTime = Date.parse(this.state.filters.endDate);
        if (isNaN(startTime)|| isNaN(endTime)) {
            return
        }
        const diffTime = endTime - startTime;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays < 0 || diffDays > 15) {
            alert("Please choose the date range of only 15 days.");
        } else {
            this.fetchRemittance();
        }
    }

    render() {
        const {remittanceList, filters} = this.state;

        remittanceList.sort((firstItem, secondItem) => {
            let firstValue = firstItem.lastUpdated ? firstItem.lastUpdated : (firstItem.submissionDate ? firstItem.submissionDate : firstItem.creationDate)
            let secondValue = secondItem.lastUpdated ? secondItem.lastUpdated : (secondItem.submissionDate ? secondItem.submissionDate : secondItem.creationDate)
            return secondValue - firstValue
        });

        return (
            this.state.showLoader ? <AppLoader/> : <Column>
                <Row>
                    {this.state.hasError && <AppNotification type="error" message={this.state.errorMessage}/>}
                </Row>
                <Row spacingInset="medium large" widths={["grid-7", "grid-4"]} alignmentVertical="top">
                    <Column >
                        <RemittanceListDateFilter filters={this.state.filters} onToggle={this.toggleOptionFilter}/>
                        {filters.showFilter ?
                            <div>
                                <Row backgroundColor="secondary" spacingInset="medium large small" >
                                    <Box>
                                        <Text type="h100">Creation Date</Text>
                                        <DateFilterForRemittance initialDate={this.state.filters.startDate} onChangeDate={this.onStartDateUpdate}/>
                                    </Box>
                                </Row>
                                <Row backgroundColor="secondary" spacingInset="small large small" >
                                    <Box>
                                        <Text type="h100">To:</Text>
                                        <DateFilterForRemittance initialDate={this.state.filters.endDate} onChangeDate={this.onEndDateUpdate}/>
                                    </Box>
                                </Row>
                            </div>
                            : null}
                    </Column>

                    <Column>
                        <Row alignmentHorizontal="end" widths="50%">
                            {this.state.submitRemittanceV2Flag && 
                                <React.Fragment>
                                    {(this.state.remittanceV2ButtonState === RemittanceStatus.CREATED || this.state.remittanceV2ButtonState === RemittanceStatus.SUBMITTED) && 
                                        <React.Fragment> 
                                            <Button onClick={this.toggleCreateRemittanceV2Modal} disabled={this.state.remittanceV2ButtonState === RemittanceStatus.SUBMITTED}>Create Remittance</Button>
                                            {this.state.openCreateRemittanceV2Modal && this.state.remittanceV2ButtonState === RemittanceStatus.CREATED && 
                                                <CreateRemittanceV2Modal currencyUnit={this.state.currencyUnit} onClose={this.toggleCreateRemittanceV2Modal} />
                                            }
                                        </React.Fragment>
                                    }
                                    {(this.state.remittanceV2ButtonState === RemittanceStatus.PENDING_SUBMISSION) && 
                                        <React.Fragment>
                                            <Button onClick={this.toggleVerifyRemittanceV2Modal}>{this.state.isVerified ? "Submit Remittance" : "Verify Remittance"}</Button>
                                            {this.state.openVerifyRemittanceV2Modal && this.state.remittanceV2ButtonState === RemittanceStatus.PENDING_SUBMISSION  &&
                                                <VerifyRemittanceV2Modal currencyUnit={this.state.currencyUnit} setVerify={this.setIsRemittanceVerified} />
                                            }
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            }
                            <Button onClick={this.togglePrepareDepositModal}>Prepare Deposit</Button>
                            <CreateRemittanceModal
                                value={this.state.openPrepareDepositModal}
                                onClose={this.togglePrepareDepositModal}
                                liabilitySummary={this.state.liabilitySummary}
                                countryCode={this.state.countryCode}
                            />
                        </Row>
                    </Column>

                </Row>

                <Row spacingInset="medium large large" widths={["grid-11"]}>
                    <Table headerRows={2} showStripes={true}>
                        <TableRow>
                            <TableCell columnSpan={6}>Remittance Details</TableCell>
                            <TableCell columnSpan={4}>Amount</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Created by</TableCell>
                            <TableCell>Creation date</TableCell>
                            <TableCell>Submitted by</TableCell>
                            <TableCell>Last Updated on</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Expected</TableCell>
                            <TableCell>Actual</TableCell>
                            <TableCell>Variance</TableCell>
                            <TableCell>Variance Reason</TableCell>
                            {!this.state.submitRemittanceV2Flag && <TableCell>&nbsp;</TableCell>}
                            <TableCell>Download as excel</TableCell>
                        </TableRow>
                        {
                            remittanceList.map(function (remittance, index) {
                                return <TableRow key={index}>
                                    <TableCell>{remittance.remittanceCode}</TableCell>
                                    <TableCell><PhoneTool value={remittance.createdBy}/></TableCell>
                                    <TableCell>{Moment(remittance.creationDate).format("YYYY-MM-DD h:mm A")}</TableCell>
                                    <TableCell>{remittance.submittedBy ?
                                        <PhoneTool value={remittance.submittedBy}/> : ''}</TableCell>
                                    <TableCell>{remittance.lastUpdated ? Moment(remittance.lastUpdated).format("YYYY-MM-DD h:mm A") : ''}</TableCell>
                                    <TableCell>{remittance.status ? remittance.status.replace("_", " ") : ""}</TableCell>
                                    <TableCell><Currency amount={remittance.expectedAmount}/></TableCell>
                                    <TableCell><Currency amount={remittance.actualAmount}/></TableCell>
                                    <TableCell><Currency amount={remittance.variance || ''} isVariance={true}/></TableCell>
                                    <TableCell>{remittance.ttLink || ''}</TableCell>
                                    
                                    {!this.state.submitRemittanceV2Flag && <React.Fragment>
                                        {remittance.remittanceCode === null &&
                                            <TableCell>
                                                <Button
                                                    id={index.toString()}
                                                    type="icon"
                                                    onClick={this.toggleAddDepositModal.bind(this, index)}>
                                                    Add Deposit Code
                                                </Button>
                                            </TableCell>
                                        }
                                        {remittance.remittanceCode !== null &&
                                            <TableCell>
                                                <Button
                                                    id={index.toString()}
                                                    type="icon"
                                                    onClick={this.toggleEditRemittanceModal.bind(this, index)}>
                                                    <Icon tokens={editTokens}/>
                                                </Button>
                                            </TableCell>
                                        }
                                    </React.Fragment>}
                                    
                                    <TableCell><RemittanceExcelDownload submitRemittanceV2Flag={this.state.submitRemittanceV2Flag} RemittanceId={remittance.remittanceId}></RemittanceExcelDownload></TableCell>
                                </TableRow>
                            }.bind(this))}
                        <AddDepositModal
                            value={this.state.openAddDepositModal}
                            onClose={this.toggleAddDepositModal}
                            addDepositModalData={this.state.addDepositModalData}
                            countryCode={this.state.countryCode}
                        />
                        {!this.state.submitRemittanceV2Flag && <EditRemittanceModal
                            value={this.state.openEditRemittanceModal}
                            onClose={this.toggleEditRemittanceModal}
                            editRemittanceModalData={this.state.editRemittanceModalData}
                        />}
                    </Table>
                </Row>
            </Column>
        );
    }
}

export default RemittanceList;


// WEBPACK FOOTER //
// ./src/component/remittance/list/remittanceList.js